import Swiper from 'swiper/bundle';

(function($) {
    if (jQuery('.quote__slider').length) {
        const swiper = new Swiper(".quote__slider", {
            loop: true,
            speed: 600,
            autoplay: {
                delay: 10000,
                disableOnInteraction: false,
				pauseOnMouseEnter: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
})(jQuery);